"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraSelectorSwitch = void 0;
var _FormDropdown = require("../../FormDropdown");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var _JoinComponent = require("../JoinComponent.styled");
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../hooks");
var _constants = require("../../../constants");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _featureFlags = require("@studio/feature.flags/featureFlags");
/**
 * Component that provides camera selection and background options (None/Blur/Custom).
 * Initializes background filter and displays error if initialization fails.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.selectedVideoInput - Currently selected video input device
 * @param {Array<Object>} props.videoInputDevices - List of available video input devices
 * @param {Function} props.onCameraChange - Callback for when camera selection changes
 * @param {boolean} props.disabled - Whether the controls should be disabled
 * @param {Function} props.initializeBackgroundFilter - Function to initialize background filter
 * @param {React.ReactNode} [props.children] - Virtual background options component (typically VirtualBackgroundOptions)
 * @returns {React.Element} Rendered component
 */
var CameraSelectorSwitch = exports.CameraSelectorSwitch = function CameraSelectorSwitch(_ref) {
  var selectedVideoInput = _ref.selectedVideoInput,
    videoInputDevices = _ref.videoInputDevices,
    onCameraChange = _ref.onCameraChange,
    disabled = _ref.disabled,
    initializeBackgroundFilter = _ref.initializeBackgroundFilter,
    virtualBackgroundComponent = _ref.children;
  var isBlurredBackgroundEnabled = (0, _featureFlags.shouldHaveFeature)('studio-agora-blurred-backgrounds');
  var backgroundFilterStatus = (0, _hooks.useInitializeBackgroundFilter)({
    initializeBackgroundFilter: initializeBackgroundFilter
  });
  var isBackgroundFilterInitialized = backgroundFilterStatus === _constants.INITIALIZATION_STATE.SUCCESS;
  var isBackgroundFilterInitializationFailed = backgroundFilterStatus === _constants.INITIALIZATION_STATE.FAILED;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormDropdown.FormDropdown, {
    labelText: "Select Camera",
    "data-testid": "selectCamera",
    selected: selectedVideoInput.device,
    options: videoInputDevices,
    id: "selectCamera",
    onChange: onCameraChange,
    disabled: disabled,
    className: "mb-0"
  }), isBackgroundFilterInitialized && isBlurredBackgroundEnabled && virtualBackgroundComponent, isBackgroundFilterInitializationFailed && /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledVirtualBackgroundErrorText, {
    type: "error",
    text: _VirtualBackground.DEVICE_NOT_SUPPORTED_MESSAGE,
    id: "virtual-background-disabled",
    "data-testid": "virtual-background-disabled"
  }));
};
CameraSelectorSwitch.propTypes = {
  selectedVideoInput: _propTypes["default"].object.isRequired,
  videoInputDevices: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  onCameraChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  initializeBackgroundFilter: _propTypes["default"].func.isRequired,
  virtualbackgorundcompnent: _propTypes["default"].node
};